/**
 * Legacy Kick logins stored ".../default-profile-pictures/default2.jpeg", which
 * returns an HTML page instead of an image and therefore never renders. Every
 * other Kick URL (including their stock "default-avatar-3.webp" / "default5-medium.webp"
 * pictures) is a real image, so we show it; anything that still fails to load
 * falls back to the initial letter via the <img> onError handler.
 */
export const isBrokenAvatar = (url?: string | null): boolean => {
    if (!url) return true;
    return /\/default-profile-pictures\/[^/]+\.jpe?g$/i.test(url);
};
